import { CompanyType } from './company-type';
import { DownloadType } from './download-type';
import { MainRelease } from './main-release';
import { Package } from './package';
import { Product } from './product';
import { ServiceRelease } from './service-release';

export * from './adobe-tracking';
export * from './breakpoint';
export * from './company-type';
export * from './download-datasource';
export * from './download-type';
export * from './main-release';
export * from './package';
export * from './package-page';
export * from './product';
export * from './product-page';
export * from './service-release';

export type Download = Product | Package | MainRelease | ServiceRelease;

export type DownloadFilter = {
  mainComponents: string;
  isArchived: boolean;
};

export function isProduct(download: Download): download is Product {
  return (
    download.type === DownloadType.PRODUKT &&
    download.company_type === CompanyType.UNSPECIFIED
  );
}

export function isPackage(download: Download): download is Package {
  return (
    download.type === DownloadType.PAKET &&
    download.company_type === CompanyType.UNSPECIFIED
  );
}

export function isMainRelease(download: Download): download is MainRelease {
  return (
    download.type === DownloadType.PAKET &&
    download.company_type === CompanyType.SMALL_MEDIUM_ENTERPRISE
  );
}

export function isServiceRelease(
  download: Download,
): download is ServiceRelease {
  return (
    download.type === DownloadType.PRODUKT &&
    download.company_type === CompanyType.SMALL_MEDIUM_ENTERPRISE
  );
}
